'use strict';

angular.module('study.i18n', [
    'gettext',
]);
